import React, { Component } from 'react'
import classes from './SetupThresholdGroup.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions
} from '../../../../helpers/utils'
import moment from 'moment'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
// import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/SetupThresholdGroup/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupThresholdGroup extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      threshold_group_name: {
        label: this.props.translate('thresholdGroup'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('thresholdGroup')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      result_type_id: {
        label: this.props.translate('resultType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('resultType'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('resultType')
            }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          type: 'text'
        },
        value: null,
        validation: {
          required: true,
          type: 'date'
        },
        valid: false,
        touched: false,
        error: null
      },
      thresholds: {
        value: [],
        validation: {},
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      threshold_group_id: {
        label: this.props.translate('thresholdGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('thresholdGroup'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('thresholdGroup')
            }
          ]
        }
      }
    },
    groups: {
      start_value: {
        label: this.props.translate('start'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('thresholdGroup')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      },
      end_value: {
        label: this.props.translate('end'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('end')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      },
      color_code: {
        label: this.props.translate('colorCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('colorCode')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    updateProps: {
      companyOptions: this.props.companyOptions,
      resultTypeOptions: this.props.resultTypeOptions,
      filterThresholdGroup: this.props.filterThresholdGroup,
      selectedRecord: this.props.selectedRecord
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('thresholdGroup'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('thresholdGroup'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.threshold_group_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('thresholdGroup'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.threshold_group_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    {
      field: 'threshold_group_name',
      title: this.props.translate('thresholdGroup'),
      type: 'string'
    },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    {
      field: 'effective_date',
      title: this.props.translate('effectiveDate'),
      type: 'string'
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchThresholdGroup()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    const updateOptions = (stateId, propsId, attr, withCode) => {
      const inputGroups = state.inputGroups
      const targetThresholdGroupItem = inputGroups[stateId]
      let [attrId, attrCode, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetThresholdGroupItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder,
            null,
            null,
            withCode ? attrCode : null
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr
      let value = state.filterControls[stateId].value
      if (props[propsId].length === 0) {
        value = 'No Data'
      }
      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.resultTypeOptions !== updateProps.resultTypeOptions) {
      updateOptions('result_type_id', 'resultTypeOptions', [
        'value_list_id',
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' },
        'Select Result Type'
      ])
    }
    if (props.filterThresholdGroup !== updateProps.filterThresholdGroup) {
      updateFilter('threshold_group_id', 'filterThresholdGroup', [
        'threshold_group_id',
        'threshold_group_name'
      ])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let { inputGroups } = state
      let newStructureData = Object.entries(inputGroups).reduce((thresholdGroups, structure) => {
        let [thresholdGroupKey, thresholdGroupAttrs] = structure
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (thresholdGroupKey === 'thresholds') {
          if (props.selectedRecord !== null) {
            value = props.selectedRecord[thresholdGroupKey]
          }
        }
        if (!thresholdGroupAttrs.validation || !thresholdGroupAttrs.validation.required) {
          valid = true
        }
        if (thresholdGroupAttrs.elementType === 'datePicker') {
          if (props.selectedRecord !== null) {
            value = new Date(props.selectedRecord[thresholdGroupKey])
          }
        }
        if (thresholdGroupAttrs.elementType === 'checkbox') {
          value = false
          valid = true
        }
        if (props.selectedRecord && props.selectedRecord[thresholdGroupKey]) {
          value = props.selectedRecord[thresholdGroupKey]
          let { isValid, error } = checkValidity(
            value,
            thresholdGroupAttrs.validation,
            thresholdGroupAttrs.label
          )
          if (thresholdGroupAttrs.elementType === 'newselect') {
            value =
              state.inputGroups[thresholdGroupKey].elementConfig.options.find(
                res => res.value === value
              ) || value
          }
          if (thresholdGroupAttrs.elementType === 'newmultiSelect') {
            value = value.map(dat => {
              return inputGroups[thresholdGroupKey].elementConfig.options.find(
                res => res.value === dat.role_id
              )
            })
          }
          if (thresholdGroupAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        const newStructureAttrs = {
          ...thresholdGroupAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }
        return updateObject(thresholdGroups, { [thresholdGroupKey]: { ...newStructureAttrs } })
      }, {})
      updatedState = {
        ...updatedState,
        formValid: true,
        inputGroups: newStructureData,
        updateProps: { ...updateProps, selectedRecord: props.selectedRecord }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchThresholdGroup(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchThresholdGroup(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'effective_date':
          newFormAttrs = {
            ...formAttrs,
            value: null
          }
          break
        case 'thresholds':
          newFormAttrs = {
            ...formAttrs,
            value: []
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})

    this.setState({
      inputGroups: newFormData
    })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchThresholdGroupById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }
  openModal = () => {
    this.setState({
      modalOpen: true,
      formValid: false
    })
  }
  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
    this.clearGroups()
  }
  clearModal = () => {
    this.clearInput()
    this.delGroup()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  thresholdGroupSubmitHandler = type => {
    let thresholdGroupData = Object.entries(this.state.inputGroups).reduce(
      (thresholdGroupData, thresholdGroupEntry) => {
        let [thresholdGroupKey, thresholdGroupAttrs] = thresholdGroupEntry
        let value = ''
        if (thresholdGroupAttrs.elementType === 'newselect') {
          value = thresholdGroupAttrs.value?.value
        } else if (thresholdGroupAttrs.elementType === 'newmultiSelect') {
          value = thresholdGroupAttrs.value.map(res => {
            return { role_id: res.value }
          })
        } else if (
          thresholdGroupAttrs.elementType === 'datePicker' &&
          typeof thresholdGroupAttrs.value !== 'string'
        ) {
          value = moment(thresholdGroupAttrs.value).format('YYYY-MM-DD')
        } else if (thresholdGroupKey === 'thresholds') {
          value = thresholdGroupAttrs.value.map(item => {
            return {
              start_value: item.start_value,
              end_value: item.end_value,
              color_code: item.color_code
            }
          })
        } else {
          value = thresholdGroupAttrs.value
        }
        return { ...thresholdGroupData, [thresholdGroupKey]: value }
      },
      {}
    )

    if (this.state.action === 'add') {
      this.props.createThresholdGroup(
        { ...thresholdGroupData },
        getPageStatus(this.props.pagination, false)
      )
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateThresholdGroup(
        this.state.actionRecordId,
        { ...thresholdGroupData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (thresholdGroupKey, event) => {
    const inputGroup = this.state.inputGroups

    const thresholdGroupItem = inputGroup[thresholdGroupKey]

    let inputValue = ''

    switch (thresholdGroupItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'datePicker':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !thresholdGroupItem.value
        break
      case 'newmultiSelect':
        inputValue = event
        break

      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(
      inputValue,
      thresholdGroupItem.validation,
      thresholdGroupItem.label
    )

    let updatedStructureItem = {
      ...thresholdGroupItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [thresholdGroupKey]: updatedStructureItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    let newStructure = inputGroup

    newStructure = updateObject(newStructure, { [thresholdGroupKey]: updatedStructureItem })

    this.setState({
      inputGroups: newStructure,
      formValid: formIsValid
    })
  }

  inputChange = (inputKey, event) => {
    let updateInputGroups = this.state.groups
    if (inputKey !== 'color_code') {
      updateInputGroups[inputKey].value = event.target.value
    } else {
      updateInputGroups[inputKey].value = event
    }

    this.setState({
      groups: updateInputGroups
    })
  }
  clearGroups = () => {
    let updateGroups = { ...this.state.groups }
    Object.entries(updateGroups).map(item => {
      let [key, att] = item
      updateGroups = {
        ...updateGroups,
        [key]: {
          ...att,
          value: ''
        }
      }
      return item
    })
    this.setState({
      groups: updateGroups
    })
  }
  addGroup = () => {
    const startVal = this.state.groups.start_value.value
    const endVal = this.state.groups.end_value.value
    const colorCode = this.state.groups.color_code.value
    if (startVal === '' || endVal === '' || colorCode === '') {
      return
    }
    let updateInputGroups = this.state.inputGroups
    updateInputGroups.thresholds.value.push({
      start_value: startVal,
      end_value: endVal,
      color_code: colorCode
    })
    this.clearGroups()
    this.setState({
      inputGroups: updateInputGroups
    })
  }

  delGroup = () => {
    let updateGroups = this.state.groups
    updateGroups = {
      start_value: {
        ...updateGroups.start_value,
        value: ''
      },
      end_value: {
        ...updateGroups.end_value,
        value: ''
      },
      color_code: {
        ...updateGroups.color_code,
        value: ''
      }
    }

    this.setState({
      groups: updateGroups
    })
  }
  delCell = row => {
    let updateDel = this.state.inputGroups
    let delGroup = updateDel.thresholds.value.filter(item => {
      return (
        item.start_value !== row.start_value ||
        item.end_value !== row.end_value ||
        item.color_code !== row.color_code
      )
    })
    updateDel.thresholds.value = delGroup
    this.setState({
      inputGroups: updateDel
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    this.props.deleteThresholdGroup(recordId, getPageStatus(this.props.pagination, true))
    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchFilter({ company_id: filterValue?.value })
    }
    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    this.props.fetchThresholdGroup(this.state.filter)
    this.closeFilterModal()
  }

  render() {
    let form = <Spinner />
    if (this.state.action === 'edit') {
      if (this.props.selectedRecord && !this.props.loading) {
        form = (
          <Form
            form={this.state.inputGroups}
            inputChanged={this.inputChangeHandler}
            formValid={this.state.formIsValid}
            selectedRecord={this.props.selectedRecord}
            groups={this.state.groups}
            groupsChanged={this.inputChange}
            addGroup={this.addGroup}
            delGroup={this.delGroup}
            delCell={row => this.delCell(row)}
          />
        )
      }
    } else if (!this.props.loading) {
      form = (
        <Form
          form={this.state.inputGroups}
          inputChanged={this.inputChangeHandler}
          formValid={this.state.formIsValid}
          groups={this.state.groups}
          groupsChanged={this.inputChange}
          addGroup={this.addGroup}
          delGroup={this.delGroup}
          delCell={row => this.delCell(row)}
        />
      )
    }

    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.thresholdGroupSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.thresholdGroupSubmitHandler('save')}
        another={() => this.thresholdGroupSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!this.state.formValid}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('thresholdGroup')}
          backdropClicked={this.closeModal}
          size={'md'}
          footer={footer}>
          <div className={classes.ModalBody}>{form}</div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('thresholdGroup')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.thresholdGroup.pagination,
    data: state.thresholdGroup.records,
    loading: state.thresholdGroup.loading,
    filterLoading: state.thresholdGroup.filterLoading,
    success: state.thresholdGroup.success,
    selectedRecord: state.thresholdGroup.selectedRecord,
    companyOptions: state.thresholdGroup.company,
    resultTypeOptions: state.thresholdGroup.resultType,
    filterThresholdGroup: state.thresholdGroup.filterThresholdGroup,
    loadingQueue: state.thresholdGroup.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchThresholdGroup: filterOptions => dispatch(actions.fetchThresholdGroup(filterOptions)),
    fetchThresholdGroupById: recordId => dispatch(actions.fetchThresholdGroupById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedThresholdGroupRecord()),
    createThresholdGroup: (recordData, page) =>
      dispatch(actions.createThresholdGroup(recordData, page)),
    updateThresholdGroup: (recordId, recordData, page) =>
      dispatch(actions.updateThresholdGroup(recordId, recordData, page)),
    deleteThresholdGroup: (recordId, page) =>
      dispatch(actions.deleteThresholdGroup(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchResultTypeOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchThresholdGroupFilterThresholdGroup(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupThresholdGroup))
